(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-collection-sort]').forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const select = form.querySelector('select');
      const submit = form.querySelector('[data-sort-submit]');
      if (!select) return;
      if (submit) submit.hidden = true;
      select.addEventListener('change', () => form.requestSubmit());
    });
    scope.querySelectorAll('.inf-collection__filter-link').forEach((link) => {
      if (link.dataset.ready) return;
      link.dataset.ready = 'true';
      const panel = document.getElementById(link.hash.slice(1));
      if (panel) panel.dataset.enhanced = 'true';
      link.addEventListener('click', () => {
        const details = document.getElementById(link.hash.slice(1));
        if (details) {
          details.open = true;
          details.querySelector('summary')?.focus();
        }
      });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
